var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('level-left',{staticClass:"content-nav"},[_vm._t("default"),_c('template',{slot:"right"},[_vm._t("right")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }